import React, { useEffect, useState } from "react";
import JobNav from "../../components/Navbar/JobNav";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const JobCategory = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const filterData = [
    {
      id: 0,
      image:
        "https://s3-alpha-sig.figma.com/img/ca0e/a7c9/688f50c415f20612a6b4a6e3d404dc84?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=ZIYIWvcik4ORJUFF~RkVLWI~vOmmD3KG02h~I0gBpnKJuD1URpQC-Uly43wNqknqHtiXJQlud-2OkPKkXcHGZtmG8qbVRiFMNYO31D7qEo52U14CYlzypLQ4WIoHDinvZbqHb-YvHPOzlNC2NwLv0jpa6GSslG7uikCGKqxs1ohF-wrI1rWIos2sZ-t0MuYQSfHMAZ9eywRqTpdQBhdxjvH1cTFEkgTsJtebhoxwGGkfSXsv-Gre9kSUTV0lvPiM8sS9Fh1-vmnHIjSn~vQRn6rebc90hJq2J-ENTkEa4qjD21qWm8TchVFe6FA~juUHWJPU7T0Jupuwq993OuiLeA__",
      heading: "Software development",
      detail: "375 open jobs",
    },
    {
      id: 1,
      image:
        "https://s3-alpha-sig.figma.com/img/2a38/c8e3/edf85d53a8c74c87d99b23e2a80466bd?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=U5ctcGzrB2gNnw136h5LKOBoLFYquu6adwkN1HGd1AulMTtudAr2GpoKvO9vCqD2~yQWbSh5xqchcLinQW-B05rpOzIPLpn~zsk7qedVovTZa85yyzdjuS-iYtthLXOKQ8b40e0ZUr9BKlRo6a-5qyewahjSHiWeJDaqWAbLORNo7Y4YwZAi0b7RiUbt-SMD6pje6EUOR2X-GCpi2yNaXLJ2U2SCCz3MnmmD41W3o~gzFAnQhlsR7iOMz34lakC-4myibeiA9Z1NI5-tgnNARcRJ3aJwYMGc5BSDJCh-N7Y0~1xmcBNtX~vC~hVDPhbUCaTgs8MmF4lg7i7SFo5YHg__",
      heading: "Data science ",
      detail: "375 open jobs",
    },
    {
      id: 2,
      image:
        "https://s3-alpha-sig.figma.com/img/6188/e7ea/48a560f3c039c537fa7d2fffad7003de?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=R-0jGspvZe0KO~aJ2VKpOI5F3hVCCo2hbMe-wUIXHtOIaxSc-HU6RqWKaq1rMTT0~cqpy~kSXIQfbIWvhfXfYoduw48~Trm1IBimnZ34zBoaok9BQI-6J2aMeUC8ULEDjPduNWeDxdis9OzJ2KGtfVxxtOLQztqkeq7o~nG0Y2jgnOtr2kxwZgVI~5nGZNMI4sn7YS~elpbii9cc6QiFIjUrm1GV67V7Ovn8Ku4tWrQw7Mzd82pzQadhNyYi1s85MZPh7ecg2OP1Bjd7xr7BV7d5FAdnrfWaczRmekk57vOkvtLIi4owVlmJ1fzcCIQVOO3VtSptOPhxhvkuhlHxJQ__",
      heading: "Database Administration",
      detail: "375 open jobs",
    },
    {
      id: 3,
      image:
        "https://s3-alpha-sig.figma.com/img/fa39/1e59/78f0e480635a0610436339ddd502d69e?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Z-rnCZ4OwRGw4XFEl1oLSbpcjhslBbA0DbCYS8umtdREQ6LdV5zZloIQWfK~KxBhoX3GFJ02Ko53iX3Rs8xgbtCYKzfNx8c0TyCl7WKe5aYYhYNQHCoRdwD61VsDuTgmrB0q-yvblLoRpa2Nk9P7zhzY6v~OyePy-yiwzMT6HFyDP~NQxHAfB4AbM8ZdaigFQ3FGJ7rSmKeBvxzXNQBcRsKmfR~ApDQsQTYW9M0l4SedKELm5hdnmmrfqPs21IKGRKX9Ge2-1dG79yzKB8iPkohHLfTkv4SB0i3p7yXgN0zEi2sOhPUJ51DT4kRCWnLTXDIIBlttbNBA6jlq7unsyQ__",
      heading: "Supply chain management",
      detail: "375 open jobs",
    },
    {
      id: 4,
      image:
        "https://s3-alpha-sig.figma.com/img/7644/72c6/84b5a6ea9ef9f5dae55a5a13a5bbe6fd?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=ssmEPIxSM75~-DcsL-Hf-bnalANQR2alhUIu-zzz74ZW5BvQtiWVJ1hMxyl9pqREnD~HPWcVJTdXt-5oM8Z8xEto8Ge0nYQWxzzFzWxg7PGhQGU0dZsuXJXnGrPXOBsrKruHy8LgkOeG0yQvQJYCFIBtPEEQJDN1EW~1a0GRC-q2KHe9FQN4aUvjDSSfix8saQjy9CsULuRlQ3L0RnvjmLShXVK3uDWr8lJyQ9l4EO2jrBOV8QsrtSbu3lPsFMqCtpfstGFyoXoZXIs6c6AjHazB2uhYcifVMSCf--zZvBXnGdC71NcpfuazftpNJdEyfUccJRG8iKD-dB183IrjPA__",
      heading: "Project/Product manager",
      detail: "375 open jobs",
    },
    {
      id: 5,
      image:
        "https://s3-alpha-sig.figma.com/img/d3a7/64b6/384857765b9ccdee3683262bf60f738a?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=V6XJ7U92I6wvQXJGgArNwAhWb2DCAiRM~t9sRTpHqsSvvZMkAG7Qbo38jGfRkjE0UzE7GP40Z4CM0vodQWr4z7gRTWMmqSQZUOlBB6HJB42YWrGJxWT1wDQw17dFiSOQhWAZ0kEsE00rGimyc9E9GOb~Q8poaGUL3e7sFFrzQaAzLPz2YXWho6IW-PVFegilg~R-LLlnjNd~cHL1JyIqkUdfTiGxrGKXhpekHUzn0lTme~Vo5LTaVNkddeHSTROVenIrDON8myyyGMTAYayJ3qdgcaPKFscbL1JTZcgQRx7mF8NEE2QBtfBdJ7H9T5pxXEvVLlUIEbYkccWDpDTEqw__",
      heading: "Content/media production",
      detail: "375 open jobs",
    },
    {
      id: 6,
      image:
        "https://s3-alpha-sig.figma.com/img/21d8/a779/3140261061b89b5238e496a2bf57b76b?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=VIJtTDKUuXQTt0XWTdel-V4mq-xaOb57moNwPEpN3GXswr0yKrC77jB70wtYBbZ3olu9linKZ2aYiIE47Tc9IlHEVc-lbZVDsJzgVRmyQtJm0v-g50ZL~sWKefpj2VNeFEwJfaYolRY0LmbUCUctZWzkn6qn4af-~GcnDLAlTSy9srSmBvW3xiCSZ1KWbsvUxkWv~PxlQ-81Xqtkj6vG1MuYd0ImVRk60LIIL0~hqEZbHbdePdKSBdYof9sbK-l6dEXMl2c6UZ5Hrmf8PB9NTVQISPgSBmF1dcX8dgY5RQZvTsT9TUcwx3t9EYTtEbWi5226s~bBs4bnUjBe8ke79g__",
      heading: "Researchers",
      detail: "375 open jobs",
    },
    {
      id: 7,
      image:
        "https://s3-alpha-sig.figma.com/img/17eb/ed5b/755bf3f686292df463879e592e17828c?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Qz2ML-Ohy0VwKJF4DFQNI0pqG1NNid7Tdlgg9o12sENgLt~L3QvpvG-ADWnlhnfEULEGHxbqG~WIdC-gp0FiFnw8hpmsP9Y3I~mG3ILSSCLjUoN0rSkS8yVYQgrCNd2v-V5~6S-eSFBrDHz3sYJLHQadMC6ZpDJnPNs-nzfbGJRZs8~S9SntjtXYTyS1jchzzjYanUXpoaqowpUBU09TzubmjKxapP9ZIH9rd1ZJZ7CeAtgzWl8-AmclkJIXihvwFdPiIifN1UwNhZ4c4kudt5eblpqFuZ8Jj9ebopnmocFNU4Q2RX4jtrpZW6XeH6LspJQxq9zKFrDV69ceH2K0zQ__",
      heading: "Administration & support",
      detail: "375 open jobs",
    },
    {
      id: 8,
      image:
        "https://s3-alpha-sig.figma.com/img/fcda/ee1f/eb97d672fd0b8669f7991763c84fda35?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=PhQai-H4H-jkK5HHaPxP7aJ9SVZ3CGVDTeWamX4izI1whsT7rYuKGVm8QDRbjn8QWWFpBP7Go0O4xqacBXh4NzZ0F-SzrwkhXoYVtc1JlBHyfMC--2HmFSDOiIjzgeWbW9vCDfUEe3dyI6hQHvErmNONi31RJFpeVPXMH-3L9aK8aTxXHhgBz8-fxZeZadupJq3DdoTOKaTAr9lBgi4nHoqrT2oWDeqxT507ci7YUjlRStwO-tAzrIfdS8G9FXhVMQHsBAqi8wEZgfoKvx0E6znYqGP~r10g3JwjfhDsASH0wS9asbszstTMxuaY4KQbkcmtljX9yOPNTstZNdp88Q__",
      heading: "Finance",
      detail: "375 open jobs",
    },
    {
      id: 9,
      image:
        "https://s3-alpha-sig.figma.com/img/48a0/9706/109de37f2bcf956271382e99eaa79fc9?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Bq3oH4n3XVD-VtSmlZbfvQIk4hpqrWRcnMja13BzXr9ww2crSKDUUVo0ASUL77Ih3-Slx5V1Kk85CHpKBzDRBmuBPcPTuOk8YgnAA8pThjRdzcfvCEnReCjs-jq4wbUeFrDYAhBWzKCMkmBSvMDkiZKCA3FRxGKDzxnK5RjWOazQEWha~LdZ0-b0TuIELuB-LKdLBVKQFTj~rTFdDoPwkHLc71HE-cihgZaFlR9r2EwOFpvU89xm8O9AZwRLpEED1AY9Buio2dmUeLVDlPdnRmF2eMkmedRrnN-Vb-WaeLclmnoDohF-XCk1P6mPV6i5ilZPRF-qCNaWCYfhYd9yPQ__",
      heading: "Human resources",
      detail: "375 open jobs",
    },
    {
      id: 10,
      image:
        "https://s3-alpha-sig.figma.com/img/c570/1850/8250b50ed00ddecc4e3fcc6a15cfb100?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=X8n8BebyEutOwxPNam1TSrWPXQi06sdUQuBXTddBLHk3obYPMbb6XjbZk0B19olW~ATejKoXr-af3sI8rRjRnUwrZP~YtDzRkOIFYan3bSizF-NNPU1-7RZVeP~MyzAzrob6iH5ULdaP1Vk7H5hDZrbSBCHUdXo2oBLamrVDhkqWlrlkIHvL~dRkjDzfATU-eV3lqV6hcHoiX-5o7SVJ0-aApjvyDM0lwscBlqVTDVFpGJ8HWfoozxjbxKD9Rt0Q65h2W~lcJC2dFz8IDHBUYHZgIvTa4vKGxAZJrFDLoQfmuIpBcogv6N3AVFbjTmUKARdkFLLboUyF21ObvV3gfg__",
      heading: "Legals",
      detail: "375 open jobs",
    },
  ];

  const isMobile = windowWidth <= 768;
  const cardStyle = {
    width: isMobile ? "calc(100% - 20px)" : "calc(25% - 20px)",
    marginBottom: "20px",
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "2%",
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className='App'>
      <JobNav />
      <Hero />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
          marginTop: "2.5%",
        }}
      >
        {filterData.map((item, index) => (
          <div key={index} style={cardStyle}>
            <Card
              image={item?.image}
              title={item?.heading}
              detail={item?.detail}
              price={item?.price}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export const Hero = () => {
  return (
    <>
      <div className='userRegister bg-gray-50'>
        <div className='container py-5'>
          <h1>Find jobs by job category</h1>
          <div className='d-flex mt-4 gap-3'>
            <div className='d-flex gap-2 pb-3'>
              <span>Browse open jobs on different job categories</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Card = (props) => {
  return (
    <div>
      <div class='card p-1 pb-4' style={{ width: "100%" }}>
        <img
          src={props.image}
          class='card-img-top'
          alt='...'
          style={{ height: 150, width: "100%", alignSelf: "center" }}
        />
        <div class='card-body'>
          <h5 class='card-title'>{props.title}</h5>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
          }}
        >
          <ul class='list-group list-group-flush'>
            <p class='card-text w-40 pl-5'>{props.detail}</p>
          </ul>
          <img
            src={require("../../Assets/image/right.png")}
            style={{ height: 24, width: 24 }}
          />
        </div>
      </div>
    </div>
  );
};

export default JobCategory;
